/**
 * * Модель создания рабочей области
 */
export class CreateNamespaceModel {
  /**Название рабочей области */
  Name!: string;
  /**ID иконки */
  IconId!: string;
  /**Адресс иконки */
  IconUrl!: string;
  /**ID цвета иконки */
  IconColorId!: string;
  /**Цвет иконки */
  IconColor!: string;
  /**Администраторы рабочей области */
  AdminIds: Array<number> = [];
  /**Идентификаторы команды рабочей области */
  TeamIds: Array<number> = [];

  constructor(obj?: Partial<CreateNamespaceModel>) {
    Object.assign(this, obj);
  }
}
